import DrawerPanel from 'modules/drawer/components/drawer-panel/drawer-panel'
import useDrawer from 'modules/drawer/state/use-drawer'
import FAQ from './faq'

const closeButtonDataId = 'faq-drawer-close-button'

const FAQDrawerPanel = () => {
  const drawer = useDrawer()

  if (!drawer.current) {
    return null
  }

  return (
    <DrawerPanel title={drawer.current.label} closeButtonDataId={closeButtonDataId}>
      <DrawerPanel.Body>
        <FAQ closeButtonDataId={closeButtonDataId} />
      </DrawerPanel.Body>
    </DrawerPanel>
  )
}

export default FAQDrawerPanel
